import { primaryColor, infoColor, successColor, warningColor, dangerColor, grayColor } from 'assets/jss/material-kit-react.js'

const timelineStyle = {
  timeline: {
    position: 'relative',
    padding: '40px 0',
    listStyle: 'none',
    margin: 0,
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: '50%',
      width: '3px',
      marginLeft: '-1.5px',
      backgroundColor: primaryColor,
      borderRadius: '2px',
    },
    '@media (max-width: 768px)': {
      '&:before': {
        left: '35px', // 与徽章位置对齐
      },
    },
    '@media (max-width: 480px)': {
      '&:before': {
        left: '32px', // 超小屏幕线条位置与徽章对齐
      },
    },
  },
  timelineItem: {
    position: 'relative',
    width: '100%',
    '&:after': {
      content: '""',
      display: 'table',
      clear: 'both',
    },
    '&:last-child': {
      marginBottom: '40px', // 最后一个元素也保留一些间距
    },
    '&:nth-child(odd)': {
      '& $timelinePanel': {
        float: 'left',
        textAlign: 'left', // 改为左对齐，更统一
        marginRight: '60px', // 给中线留出空间
      },
    },
    '&:nth-child(even)': {
      '& $timelinePanel': {
        float: 'right',
        textAlign: 'left',
        marginLeft: '60px', // 给中线留出空间
      },
    },
    '@media (max-width: 768px)': {
      marginLeft: '70px', // 减少左边距，让面板更好对齐
      marginBottom: '80px', // 增加下边距，防止徽章重叠
    },
    '@media (max-width: 480px)': {
      marginLeft: '65px', // 超小屏幕调整
      marginBottom: '70px',
    },
  },
  timelinePanel: {
    position: 'relative',
    width: '45%',
    background: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
    border: '1px solid #e0e0e0',
    marginTop: '30px', // 给徽章留出空间
    '@media (max-width: 768px)': {
      width: 'calc(100% - 70px) !important', // 强制应用宽度
      marginTop: '35px !important', // 增加顶部间距，避免与徽章重叠
      marginLeft: '10px !important', // 添加左边距，让面板内容更好对齐
      marginRight: '0 !important', // 重置右边距
      padding: '18px', // 稍微减少内边距，适应小屏幕
      float: 'none !important', // 取消浮动
    },
    '@media (max-width: 480px)': {
      width: 'calc(100% - 65px) !important', // 超小屏幕宽度
      padding: '16px',
      marginLeft: '-5px !important',
      marginTop: '30px !important',
      marginLeft: '8px !important', // 超小屏幕的左边距
    },
  },
  timelineBadge: {
    position: 'absolute',
    top: '-30px', // 将徽章放在卡片上方
    left: '50%',
    width: '80px',
    height: '80px',
    marginLeft: '-40px',
    borderRadius: '50%',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#fff',
    zIndex: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '4px solid #fff',
    boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
    backgroundColor: primaryColor, // 确保有背景色
    '@media (max-width: 768px)': {
      left: '-10px', // 调整徽章左侧位置，与面板更好对齐
      marginLeft: '-25px', // 微调位置，更好对齐
      width: '50px',
      height: '50px',
      fontSize: '9px',
      top: '-15px', // 调整顶部位置，减少与面板重叠
      border: '3px solid #fff',
    },
    '@media (max-width: 480px)': {
      left: '-10px', // 超小屏幕徽章位置
      width: '45px',
      height: '45px',
      fontSize: '8px',
      top: '-12px',
      marginLeft: '-22px',
      border: '2px solid #fff',
    },
  },
  timelineDate: {
    textAlign: 'center',
    lineHeight: 1.1,
    fontWeight: 'bold',
    whiteSpace: 'pre-line',
    fontSize: '16px',
    '@media (max-width: 768px)': {
      fontSize: '12px',
      lineHeight: 1.2,
    },
    '@media (max-width: 480px)': {
      fontSize: '11px',
    },
  },
  timelineBody: {
    position: 'relative',
  },
  timelineContentItem: {
    marginBottom: '15px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  timelineTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px',
    color: '#333',
    '@media (max-width: 768px)': {
      fontSize: '17px',
      marginBottom: '10px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      marginBottom: '8px',
    },
  },
  timelineDescription: {
    fontSize: '15px',
    lineHeight: 1.7,
    color: '#666',
    margin: 0,
    marginBottom: '8px',
    whiteSpace: 'pre-line',
    '& strong': {
      fontWeight: 'bold',
      color: '#ed5555', // 红色强调
      fontSize: '16px',
    },
    '& a': {
      color: '#3949AB',
      fontWeight: '700',
      position: 'relative',
      textDecoration: 'none',
      borderBottom: '2px solid #3949AB',
      paddingBottom: '1px',
      transition: 'all 0.3s ease',
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: '-2px',
        left: '0',
        width: '0',
        height: '2px',
        background: 'linear-gradient(90deg, #3949AB, rgba(57, 73, 171, 0.6))',
        transition: 'width 0.3s ease',
      },
      '&:hover': {
        color: 'rgba(57, 73, 171, 0.8)',
        borderBottomColor: 'rgba(57, 73, 171, 0.8)',
        transform: 'translateY(-1px)',
        '&:after': {
          width: '100%',
        },
      },
    },
    '@media (max-width: 768px)': {
      fontSize: '14px',
      lineHeight: 1.6,
      marginBottom: '6px',
      '& strong': {
        fontSize: '14px',
      },
      '& a': {
        fontSize: '14px',
        borderBottom: '1px solid #3949AB',
        '&:after': {
          height: '1px',
        },
      },
    },
    '@media (max-width: 480px)': {
      fontSize: '13px',
      lineHeight: 1.5,
      '& strong': {
        fontSize: '13px',
      },
      '& a': {
        fontSize: '13px',
        borderBottom: '1px solid #3949AB',
        '&:after': {
          height: '1px',
        },
      },
    },
  },
  timelineSupplement: {
    fontSize: '13px',
    lineHeight: 1.6,
    color: '#888',
    margin: 0,
    marginTop: '6px',
    fontStyle: 'italic',
    backgroundColor: '#f8f9fa',
    padding: '8px 12px',
    borderRadius: '4px',
    borderLeft: '3px solid #ddd',
    '@media (max-width: 768px)': {
      fontSize: '12px',
      lineHeight: 1.5,
      padding: '6px 10px',
      marginTop: '4px',
    },
    '@media (max-width: 480px)': {
      fontSize: '11px',
      padding: '5px 8px',
      borderLeft: '2px solid #ddd',
    },
  },
  // 不同颜色的时间轴徽章
  primary: {
    backgroundColor: primaryColor,
    '&:hover': {
      backgroundColor: primaryColor,
    },
  },
  info: {
    backgroundColor: infoColor,
    '&:hover': {
      backgroundColor: infoColor,
    },
  },
  success: {
    backgroundColor: successColor,
    '&:hover': {
      backgroundColor: successColor,
    },
  },
  warning: {
    backgroundColor: warningColor,
    '&:hover': {
      backgroundColor: warningColor,
    },
  },
  danger: {
    backgroundColor: dangerColor,
    '&:hover': {
      backgroundColor: dangerColor,
    },
  },
}

export default timelineStyle
